import { trackEventServerSide } from "helpers/api";
import { getMajorVersion } from "helpers/services/mixpanel";
import {
  MixpanelActionSource,
  MixpanelEvent,
  NewThreadEvent,
  SearchEvent,
} from "helpers/services/mixpanel/events";
import { useNewSearchSettingsProperties } from "hooks/useNewSearchSettingsProperties";
import { useAppSelector } from "hooks/useStore";
export function useNewThreadEvents() {
  const navigationSource = useAppSelector(
    (state) => state.analytic.navigationSource
  );
  const { newSearchSettingsProperties } = useNewSearchSettingsProperties();

  const trackSearch = (
    userMessage: string,
    actionSource?: MixpanelActionSource
  ) => {
    const eventData: SearchEvent = {
      event: MixpanelEvent.Search,
      ...newSearchSettingsProperties,
      actionSource,
      query: userMessage,
      isNewThread: true,
      navigationSource,
      version: getMajorVersion(),
    };

    trackEventServerSide(eventData);
  };

  const trackNewThread = (
    query: string,
    actionSource: MixpanelActionSource
  ) => {
    const eventData: NewThreadEvent = {
      event: MixpanelEvent.NewThread,
      ...newSearchSettingsProperties,
      actionSource,
      query,
      version: getMajorVersion(),
    };

    trackEventServerSide(eventData);
  };

  return {
    trackSearch,
    trackNewThread,
  };
}
